<template>
  <div class="page-content conmon-top">
    <div
      class="base-input ovf-hd"
      style="margin-bottom: 10px;"
    >
      <el-row class="search-title">
        <el-col
          :span="4"
          class="search-nav-left"
        >
          <i
            class="el-icon-search"
            style="font-weight: bold;"
          ></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col
          :span="20"
          class="search-nav-right"
        >
          <el-button
            class="search-open-close"
            type="text"
            @click="hide=!hide"
            v-show="hide"
          >收起查询</el-button>
          <el-button
            class="search-open-close"
            type="text"
            @click="hide=!hide"
            v-show="!hide"
          >展开查询</el-button>
          <i
            v-if="hide === true"
            class="el-icon-arrow-up search-open-close-i"
            @click="hide=!hide"></i>
          <i
            v-if="hide === false"
            class="el-icon-arrow-down search-open-close-i"
            @click="hide=!hide"></i>
          <el-button
            class="search-btn-new"
            type="primary"
            size="small"
            @click="getDataListWay()"
          >查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div
          v-show="hide"
          class="search-content common-search-formtype"
        >
          <el-form
            :inline="true"
            label-width="95px"
            class="search-content-item"
          >
            <el-form-item label="订单来源：">
              <el-select
                v-model="orderSourceSystem"
                clearable
                placeholder="请选择订单来源"
              >
                <el-option
                  v-for="item in resourceTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单类型：">
              <el-select
                      v-model="orderType"
                      clearable
                      placeholder="请选择订单类型"
              >
                <el-option
                        v-for="item in orderTypeListArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单编号：">
              <el-input
                v-model="orderNo"
                placeholder="请输入订单编号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="订单状态：">
              <el-select
                      @change="changeState"
                      v-model="orderStatus"
                      clearable
                      placeholder="请选择订单状态"
              >
                <el-option
                        v-for="item in orderTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="买家信息：">
              <el-input
                v-model="buyerKey"
                placeholder="昵称/收货人/手机号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间：" style="margin-bottom: 0;">
              <el-date-picker
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="searchDateObj.createTimeStart"
                      type="datetime"
                      @change = "changehandle"
                      placeholder="开始日期">
              </el-date-picker>
              <span style="padding: 0 5px">至</span>
              <el-date-picker
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="searchDateObj.createTimeEnd"
                      type="datetime"
                      @change = "changehandle"
                      placeholder="结束日期">
              </el-date-picker>
<!--              <el-date-picker-->
<!--                      value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                      class="micro-page-picker"-->
<!--                      style="width:350px!important;margin-top: 15px"-->
<!--                      v-model="timeDate"-->
<!--                      type="datetimerange"-->
<!--                      range-separator="至"-->
<!--                      start-placeholder="开始日期"-->
<!--                      end-placeholder="结束日期">-->
<!--              </el-date-picker>-->
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row
      class="search-title common-table-top"
      style="padding-right:0;border-bottom: 0px"
    >
      <el-col
        :span="4"
        style="text-align: left;"
      >
        <i
          class="el-icon-document"
          style="font-weight: bold;"
        ></i>
        <span class="order-list-search-span">订单列表</span>
      </el-col>
      <el-col
        :span="20"
        class="text-align-right"
      >
        <el-button
          type="primary" v-show="btnType.export"
          class="add-btn btn-right"
          style="float: right;"
          @click="toExport"
        >导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <!-- 表格 -->
      <div class = "tabsList">
        <div>
        <ul>
          <li v-for="(item, index) in orderTypeList" :key="index">
            <span :class="orderActive ===item.value? 'activeTab' : ''" @click="handleClick(item.value)">{{item.label}}</span>
          </li>
        </ul>
        </div>
<!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
<!--          <el-tab-pane :label="item.label" :name="item.value" v-for="(item, index) in orderTypeList" :key="index"></el-tab-pane>-->
<!--        </el-tabs>-->
        <div v-loading="loadList">
        <table>
          <thead class="theadProd">
          <tr>
            <th style="text-align: left;padding: 0 20px">产品名称</th>
            <th width="140" style="text-align: left;padding: 0 20px">销售价</th>
            <th width="40" style="text-align: left;padding: 0 20px">数量</th>
            <th style="text-align: left;padding: 0 20px">支付金额/积分</th>
            <th style="text-align: left;padding: 0 20px">买家/收货人信息</th>
            <th width="70" style="text-align: left;padding: 0 20px">订单状态</th>
            <th style="width: 70px">操作</th>
          </tr>
          </thead>
          <tbody class="applytable" v-for="(item, index) in tableData" :key="index">
          <tr><td colspan="7" style="background-color: #fff;height: 15px"></td></tr>
          <tr class="tbodyProdOne">
            <td colspan="7">
              <span>订单编号:{{item.orderNo}}</span>
              <span>订单来源:{{item.orderSourceSystem === 'ZY_GROUP'? '云团':(item.orderSourceSystem === 'CLOUD_SHOP'? '云店': (item.orderSourceSystem === 'ZY_MEMBER'?'云众':''))}}</span>
              <span>订单类型：{{item.orderType == 1? '拼团订单': (item.orderType == 2?'线下订单':(item.orderType == 3?'积分订单':(item.orderType == 4?'团购订单':(item.orderType == 5?'直播订单':(item.orderType == 6?'秒杀':(item.orderType == 7?'阶梯拼团':''))))))}}</span>
              <span>创建时间：{{item.createTime}}</span>
              <span v-if="item.giftNameIs==1">赠品：{{item.giftName}}</span>
            </td>
          </tr>
          <tr class="contentTabProd" v-for="(ite, ind) in item.goodsList" :key="ind">
            <td >
              <div class="imgTabProd">
                <img v-if="ite.goodsImage!=''&& ite.goodsImage!=null" :src = "ite.goodsImage">
                <img v-else src = "http://member.intelliquor.com/member/applet/orderDefaultNew.png">
                <span @click="toDetail(item.id)" style="cursor: pointer">
                  {{ite.goodsName}}
                </span>
              </div>
            </td>
            <td style="text-align: left">{{ite.goodsValue}}</td>
            <td style="text-align: left">{{ite.quantity}}</td>
            <td style="text-align: left" v-if="ind ==0"  :rowspan="item.goodsList.length==0?1: item.goodsList.length">
              <div>{{item.payContent}}</div>
              <div>{{item.payType==1? '微信支付': (item.payType ==2? '银行转账': (item.payType ==3?'货到付款':(item.payType ==4?'积分': (item.payType ==5?'积分+现金支付': ''))))}}</div>
              <div v-if="item.expressPrice!='' && item.expressPrice!=null">(含快递￥ {{item.expressPrice}})</div>
            </td>
            <td v-if="ind ==0" :rowspan="item.goodsList.length==0?1: item.goodsList.length">
              <div  class="userTabProd">
                <div>昵称：{{item.nickname}}</div>
                <div>收货人：{{item.receiverName}} </div>
                <div>手机号：{{item.receiverMobile}}</div>
              </div>
            </td>
            <td v-if="ind ==0" :rowspan="item.goodsList.length==0?1: item.goodsList.length" style="text-align: left">
              <span v-if="item.orderStatus ==='unpaid'">未支付</span>
              <span v-if="item.orderStatus ==='wait_group'">待成团</span>
              <span v-if="item.orderStatus ==='wait_deliver'">待发货</span>
              <span v-if="item.orderStatus ==='wait_receive'">已发货</span>
              <span v-if="item.orderStatus ==='unverified'">未核销</span>
              <span v-if="item.orderStatus ==='verified'">已核销</span>
              <span v-if="item.orderStatus ==='closed'">已关闭</span>
              <span v-if="item.orderStatus ==='completed'">已完成</span>
              <span v-if="item.orderStatus ==='group_failed'">拼团失败</span>
              <span v-if="item.orderStatus ==='refunded'">已退款</span>
              <span v-if="item.orderStatus ==='refund_failed'">退款失败</span>
              <span v-if="item.orderStatus ==='refunding'">退款中</span>
            </td>
            <td v-if="ind ==0" :rowspan="item.goodsList.length==0?1: item.goodsList.length" style="width: 70px"><span class="detail" v-show="btnType.details" @click="toDetail(item.id)">详情</span></td>
          </tr>
          </tbody>
        </table>
        <div v-if= "tableData.length===0" class="blankOrder" align="center">
          没有更多数据了
        </div>
        </div>
      </div>
<!--      v-loading="loadList"-->
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getOrderList,butonsList,getMenId } from '@/api/analyse.js'
import { getOrderExport } from '@/api/set.js'
export default {
  name: 'boardList',
  data () {
    return {
      tableData: [],
      buyerKey: '',
      orderType: '',
      // 1 拼团；2 线下订单；3 积分兑换 4 团购 5 直播订单
      orderTypeListArr: [
        {label:'拼团订单',value:'1'},
        {label:'线下订单',value:'2'},
        {label:'积分订单',value:'3'},
        {label:'团购订单',value:'4'},
        {label:'直播订单',value:'5'},
        {label:'秒杀',value:'6'},
        {label:'阶梯拼团',value:'7'}
        ],
      orderStatus: '',
      orderSourceSystem: '',
      orderNo: '',
      timeDate: [],
      hide: true,
      searchDateObj: {
        page: 1,
        limit: 10,
        sortCode: '',
        sortRole: '',
        orderSourceSystem: '',
        orderNo: '',
        orderStatus: 0,
        buyerKey: '',
        createTimeStart: '',
        createTimeEnd: ''
      }, // 查询数据
      resourceTypeList: [{
        label: '云众',
        value: 'ZY_MEMBER'
      }, {
        label: '云店',
        value: 'CLOUD_SHOP'
      }, {
        label: '云团',
        value: 'ZY_GROUP'
      }], // 来源列表
      activeName: '',
      orderActive: '',
      //  0未支付 1待成团 2代发货(21仓库接单 22仓库打包中 23已出库)
      //  3已发货 4未核销 5已核销 6已关闭 7已完成 8拼团失败 9已退款 10退款中
      orderTypeList: [{
        label: '全部',
        value: ''
      }, {
        label: '待支付',
        value: 'unpaid'
      }, {
        label: '待发货',
        value: 'wait_deliver'
      }, {
        label: '已发货',
        value: 'wait_receive'
      }, {
        label: '已完成',
        value: 'completed'
      }, {
        label: '已关闭',
        value: 'closed'
      }, {
        label: '退款中',
        value: 'refunding'
      }, {
        label: '已退款',
        value: 'refunded'
      }, {
        label: '退款失败',
        value: 'refund_failed'
      }, {
        label: '待成团',
        value: 'wait_group'
      }, {
        label: '拼团失败',
        value: 'group_failed'
      }], // 订单类型列表
      isSafari: false,
      loadList: false,
      totalCount: 0,
      limit: 10,
      page: 1,
      btnType:{
        'export':false,
        'details':false
      }
    }
  },
  methods: {
    changehandle() {
      if(this.searchDateObj.createTimeStart == null) {
        this.searchDateObj.createTimeStart = ''
      }
      if(this.searchDateObj.createTimeEnd == null) {
        this.searchDateObj.createTimeEnd = ''
      }
      let start = new Date(this.searchDateObj.createTimeStart).getTime()
      let end = new Date(this.searchDateObj.createTimeEnd).getTime()
      if(this.searchDateObj.createTimeStart.length==0 && this.searchDateObj.createTimeEnd.length!=0) {
        _g.toastMsg('error', '请选择开始时间')
        return
      } else if(start > end) {
          _g.toastMsg('error', '结束时间不能大于开始时间')
        return
      }
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    toExport () {
      if(this.searchDateObj.createTimeStart == null) {
        this.searchDateObj.createTimeStart = ''
      }
      if(this.searchDateObj.createTimeEnd == null) {
        this.searchDateObj.createTimeEnd = ''
      }
      let params =  {
        orderType: this.orderType,
        sortCode: '',
        sortRole: '',
        orderSourceSystem: this.orderSourceSystem,
        orderNo: this.orderNo,
        orderStatus: this.orderStatus,
        buyerKey: this.buyerKey,
        createTimeStart: this.searchDateObj.createTimeStart || '',
        createTimeEnd:this.searchDateObj.createTimeEnd || ''
      }
      let start = new Date(this.searchDateObj.createTimeStart).getTime()
      let end = new Date(this.searchDateObj.createTimeEnd).getTime()
      if(this.searchDateObj.createTimeStart.length==0 && this.searchDateObj.createTimeEnd.length!=0) {
        _g.toastMsg('error', '请选择开始时间')
        return
      } else if(this.searchDateObj.createTimeEnd.length==0 && this.searchDateObj.createTimeStart.length!==0) {
        _g.toastMsg('error', '请选择结束时间')
        return
      }  else if(start > end) {
        _g.toastMsg('error', '结束时间不能大于开始时间')
        return
      } else {
        getOrderExport(params).then(response => {
          _g.toastMsg('href1', '')
          this.exportDialog = false
        }).catch((error) => {
          _g.toastMsg('error', error)
        })
      }

    },
    changeState (val) {
    },
    getDataListWay () {
      if(this.searchDateObj.createTimeStart == null) {
        this.searchDateObj.createTimeStart = ''
      }
      if(this.searchDateObj.createTimeEnd == null) {
        this.searchDateObj.createTimeEnd = ''
      }
      this.orderActive = this.orderStatus
      let params =  {
        page: this.page,
        limit: this.limit,
        sortCode: '',
        sortRole: '',
        orderSourceSystem: this.orderSourceSystem,
        orderNo: this.orderNo,
        orderStatus: this.orderStatus,
        orderType: this.orderType || '',
        buyerKey: this.buyerKey,
        createTimeStart: this.searchDateObj.createTimeStart || '',
        createTimeEnd: this.searchDateObj.createTimeEnd || ''
      }
      console.log(params, 'this.params')
      let start = new Date(this.searchDateObj.createTimeStart).getTime()
      let end = new Date(this.searchDateObj.createTimeEnd).getTime()
      if(this.searchDateObj.createTimeStart.length==0 && this.searchDateObj.createTimeEnd.length!=0) {
        _g.toastMsg('error', '请选择开始时间')
        return
      } else if(this.searchDateObj.createTimeEnd.length==0 && this.searchDateObj.createTimeStart.length!==0) {
        _g.toastMsg('error', '请选择结束时间')
        return
      }  else if(start > end) {
        _g.toastMsg('error', '结束时间不能大于开始时间')
        return
      } else {
        this.loadList = true
        getOrderList(params).then(res => {
          console.log(res, 'res')
          if (res.data.code === 200 || res.data.code === '200') {
            this.totalCount = res.data.result.total
            res.data.result.list.map(function(item,index){
              item.giftName = ''
              item.giftNameIs = 0
              let goodsList = item.goodsList
              let newgoodsList = []
              goodsList.map(function(it,ind){
                if(it.gift == 1) {
                  item.giftName = it.goodsName
                  item.giftNameIs = 1
                } else {
                  newgoodsList.push(it)
                }
              })
              item.goodsList = newgoodsList
            })
            this.tableData = res.data.result.list
            console.log(this.tableData, 'this.tableData')
          } else {
            this.tableData = []
            this.totalCount = 0
            _g.toastMsg('error', res.data.message)
          }
          this.loadList = false
        })
      }

    },
    // 选择订单状态
    handleClick(val) {
      this.orderActive = val
      this.orderStatus = val
      this.page = 1
      this.getDataListWay()
    },
    //
    toDetail(id) {
      router.push({ path: '/home/order-manage-detail', query: { orderId: id }})

    },
    // 处理分页
    handleSizeChange (val) {
      // this.searchDataObj.limit = val
    },
    handleCurrentChange (page) {
      this.page = page
      this.getDataListWay()
    },
  },
  created () {
    this.page = 1
    let test = '{"9a":{"answer":"","sccOrder":"","sccoMark":""},"9b":{"answer":"","sccOrder":"","sccoMark":""},"7a":{"answer":"","sccOrder":"","sccoMark":""},"9c":{"answer":"","sccOrder":"","sccoMark":""},"7b":{"answer":"","sccOrder":"","sccoMark":""},"5a":{"answer":"","sccOrder":"","sccoMark":""},"7c":{"answer":"","sccOrder":"","sccoMark":""},"5b":{"answer":"","sccOrder":"","sccoMark":""},"3a":{"answer":"A","sccOrder":"7","sccoMark":"0"},"5c":{"answer":"","sccOrder":"","sccoMark":""},"3b":{"answer":"A","sccOrder":"8","sccoMark":"0"},"1a":{"answer":"A","sccOrder":"1","sccoMark":"0"},"3c":{"answer":"A","sccOrder":"9","sccoMark":"0"},"1b":{"answer":"A","sccOrder":"2","sccoMark":"0"},"1c":{"answer":"A","sccOrder":"3","sccoMark":"0"},"10a":{"answer":"","sccOrder":"","sccoMark":""},"10b":{"answer":"","sccOrder":"","sccoMark":""},"10c":{"answer":"","sccOrder":"","sccoMark":""},"8a":{"answer":"","sccOrder":"","sccoMark":""},"8b":{"answer":"","sccOrder":"","sccoMark":""},"6a":{"answer":"","sccOrder":"","sccoMark":""},"8c":{"answer":"","sccOrder":"","sccoMark":""},"6b":{"answer":"","sccOrder":"","sccoMark":""},"4a":{"answer":"A","sccOrder":"10","sccoMark":"0"},"6c":{"answer":"","sccOrder":"","sccoMark":""},"4b":{"answer":"A","sccOrder":"11","sccoMark":"0"},"2a":{"answer":"A","sccOrder":"4","sccoMark":"0"},"4c":{"answer":"","sccOrder":"","sccoMark":""},"2b":{"answer":"A","sccOrder":"5","sccoMark":"0"},"2c":{"answer":"A","sccOrder":"6","sccoMark":"0"}}'
    let my = JSON.parse(test)
    console.log(my)
    let maxsccOrder = 0
    for(var key in my){
      // console.log(my[key], '===')
      if (parseInt(my[key].sccOrder) > maxsccOrder) {
        maxsccOrder = parseInt(my[key].sccOrder)
      }
    }
    console.log(maxsccOrder, '最大题号')
    // console.log(Array.form(my))
    // this.getDataListWay()
    // this.queryBtnList()
  }
}
</script>

<style scoped>
  .blankOrder {
    width: 100%;
    text-align: center;
    padding: 25px 0 10px 0;
  }
  .detail {
    color: #1980FF;
    font-size: 14px;
    cursor: pointer;
  }
  .contentTabProd {
    border: 1px solid #E7E7E7;
  }
  .contentTabProd td {
    border-right: 1px solid #E7E7E7;
    padding: 10px 20px;
  }
  .imgTabProd {
    word-wrap: break-word;
    white-space: normal;
    word-break: break-all;
    color: #1980FF;
    font-size: 14px;
    line-height: 25px;
    position: relative;
    padding-left: 50px;
    text-align: left;
  }
  .imgTabProd img{
    position: absolute;
    top: 50%;
    margin-top: -18px;
    left: 0px;
    width: 36px;
    height: 36px;
  }
  .userTabProd {
    word-wrap: break-word;
    white-space: normal;
    word-break: break-all;
    text-align: left;
  }
  .theadProd tr{
    background-color: #F0F0F0;
    padding: 10px 0;
    height: 45px;
  }
  .tbodyProdOne td{
    border: 1px solid #E7E7E7;
    text-align: left!important;
    padding-left: 20px;
    background-color: #F5F5F5;
    height: 40px;
    margin-top: 15px;
  }
  .tbodyProdOne td span{
    font-size: 14px;
    text-align: left;
    padding-right: 30px;
  }
  table{font-size: 14px;color: #5a5a5a; width: 100%;table-layout: fixed;}
  table thead tr th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  table thead tr th:first-child{min-width: 15%;font-size: 14px}
  table tbody tr td{
    font-size: 14px;
  }
  .tabsList {
    background-color: #fff;
    margin: 0 24px;
    padding: 0px 30px;
     overflow: hidden;
  }
  .tabsList >div{
    width: 100%;
  }
  .tabsList ul {
    border-bottom: 1px solid #E7E7E7;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .tabsList ul li {
    text-align: center;
    list-style: none;
    display: flex;
    justify-content: center;
  }
  .tabsList ul li span{
    cursor: pointer;
    padding: 10px 15px;
    margin: 0 15px -1px 0;
  }
  .tabsList ul li .activeTab {
    border-bottom: 2px solid #1980FF;
    color: #1980FF;
  }
  .sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
  color: #1980ff;
  cursor: pointer;
  font-size: 14px;
}
.right {
  width: 370px;
}
</style>
